export default __webpack_public_path__ + "static/button_blue_down-1ae4c27131227acaef3d84b1c8a13cc5.png";